/* eslint-disable max-len */
// ref: https://github.com/porsche-design-system/porsche-design-system/blob/main/packages/components/src/components/popover/
import { Popconfirm as AntdPopconfirm, type PopconfirmProps as AntdPopconfirmProps } from 'antd';

const Popconfirm = ({ okButtonProps, cancelButtonProps, icon = null, ...props }: AntdPopconfirmProps) => (
    <AntdPopconfirm
        {...props}
        cancelButtonProps={{
            ...cancelButtonProps,
            style: {
                color: '#010205',
                border: '1px solid #010205',
                borderRadius: '4px',
                font: "normal normal 400 0.75rem/calc(6px + 2.125ex) 'Porsche Next','Arial Narrow',Arial,'Heiti SC',SimHei,sans-serif",
            },
        }}
        icon={icon}
        okButtonProps={{
            ...okButtonProps,
            style: {
                borderRadius: '4px',
                font: "normal normal 400 0.75rem/calc(6px + 2.125ex) 'Porsche Next','Arial Narrow',Arial,'Heiti SC',SimHei,sans-serif",
            },
        }}
        overlayInnerStyle={{
            ...props.overlayInnerStyle,
            position: 'absolute',
            maxWidth: 'min(90vw, 27rem)',
            width: 'max-content',
            boxSizing: 'border-box',
            background: '#FFF',
            padding: '0',
            pointerEvents: 'auto',
            bottom: '100%',
            left: '50%',
            transform: 'translate3d(-50%, 0, 0)',
            font: "normal normal 400 1rem/calc(6px + 2.125ex) 'Porsche Next','Arial Narrow',Arial,'Heiti SC',SimHei,sans-serif",
            overflowWrap: 'break-word',
            hyphens: 'auto',
            listStyleType: 'none',
            color: '#010205',
            whiteSpace: 'inherit',
            borderRadius: '4px',
        }}
        overlayStyle={{
            overflow: 'initial',
            backgroundColor: 'transparent',
            border: 'none',
            margin: '0',
            padding: '0',
            position: 'absolute',
            zIndex: '9999',
            filter: 'drop-shadow(0 0 16px rgba(0,0,0,0.3))',
            backdropFilter: 'drop-shadow(0px 0px 0px transparent)',
            pointerEvents: 'none',
        }}
    />
);

export default Popconfirm;
